import { __read } from "tslib";
import { useEffect, useRef, useState } from 'react';
import { createPortal } from 'react-dom';
import { canUseDOM } from '../lib/canUseDOM';
var canUseDom = canUseDOM();
var defaultContainer = canUseDom ? document.body : null;
/**
 * Реакт-компонент, позволяющий рендерить содержимое в указанном контейнер,
 * обладает ленивым рендерингом и умеет очищать содержимое после скрытия.
 */
export var Portal = function (props) {
    var visible = props.visible, _a = props.keepMounted, keepMounted = _a === void 0 ? true : _a, children = props.children, scope = props.scope;
    var _b = __read(useState(defaultContainer), 2), container = _b[0], setContainer = _b[1];
    var isPortalDisabled = scope === 'inplace';
    var isWasVisibleRef = useRef(false);
    useEffect(function () {
        if (typeof scope === 'object') {
            setContainer(scope.current);
        }
    }, [scope]);
    if (visible) {
        isWasVisibleRef.current = true;
    }
    var shouldClientRender = canUseDom && (visible || (keepMounted && isWasVisibleRef.current));
    var shouldServerRender = !canUseDom && visible;
    if (!shouldClientRender && !shouldServerRender) {
        return null;
    }
    if (isPortalDisabled) {
        return children;
    }
    return container ? createPortal(children, container) : null;
};
if (process.env.NODE_ENV !== 'production') {
    Portal.displayName = 'Portal';
}
